var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V9C0 15.59 3.19 19.5838 5.86625 21.7738C8.74875 24.1313 11.6163 24.9325 11.7413 24.965C11.9131 25.0118 12.0944 25.0118 12.2663 24.965C12.3913 24.9325 15.255 24.1313 18.1413 21.7738C20.81 19.5838 24 15.59 24 9V2C24 1.46957 23.7893 0.960859 23.4142 0.585786C23.0391 0.210714 22.5304 0 22 0ZM22 9C22 13.6337 20.2925 17.395 16.925 20.1775C15.4591 21.3846 13.7919 22.324 12 22.9525C10.2315 22.335 8.58493 21.4123 7.135 20.2262C3.7275 17.4387 2 13.6625 2 9V2H22V9Z",
    fill: "#A38150"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc2);
export default __webpack_public_path__ + "static/media/ic2.caabd025854951734bee2dd7dba2914f.svg";
export { ForwardRef as ReactComponent };